import React, { useState, useEffect } from 'react';
import { Container, ContentButtons } from './styles';
import { smallDateFormat } from '../../../../../utils/Utils';
import { Chart as ChartJS, BarElement, CategoryScale, LinearScale, Tooltip, Legend } from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

const NpsGraph = ({ graph_active_day_by_day }) => {
  const [filteredData, setFilteredData] = useState(graph_active_day_by_day);
  const [filter, setFilter] = useState('month');

  useEffect(() => {
    if (filter === 'month') {
      setFilteredData(formatDataByMonth(graph_active_day_by_day));
    } else if (filter === 'year') {
      setFilteredData(formatDataByYear(graph_active_day_by_day));
    } else {
      setFilteredData(formatDataByDay(graph_active_day_by_day));
    }
  }, [filter, graph_active_day_by_day]);

  const formatDataByMonth = (data) => {
    const groupedByMonth = data.reduce((acc, curr) => {
      const month = curr.date.slice(0, 7); // Formato YYYY-MM
      if (!acc[month]) {
        acc[month] = 0;
      }
      acc[month] += curr.mediaGeral;
      return acc;
    }, {});
    return Object.keys(groupedByMonth)?.map(month => ({
      date: month,
      mediaGeral: (groupedByMonth[month] / data.filter(d => d.date.slice(0, 7) === month).length).toFixed(2)
    }));
  };

  const formatDataByYear = (data) => {
    const groupedByYear = data.reduce((acc, curr) => {
      const year = curr.date.slice(0, 4); // Formato YYYY
      if (!acc[year]) {
        acc[year] = 0;
      }
      acc[year] += curr.mediaGeral;
      return acc;
    }, {});
    return Object.keys(groupedByYear)?.map(year => ({
      date: year,
      mediaGeral: (groupedByYear[year] / data.filter(d => d.date.slice(0, 4) === year).length).toFixed(2)
    }));
  };

  const formatDataByDay = (data) => {
    return data.slice(-10)?.map(d => ({
      date: d.date.slice(0, 10),
      mediaGeral: d.mediaGeral.toFixed(2)
    })); // Últimos 10 dias
  };

  const getLabel = (date) => {
    if (filter === 'month') {
      const [year, month] = date.split('-');
      return new Date(year, month - 1).toLocaleString('pt-br', { month: 'long' });
    }
    if (filter === 'year') {
      return date;
    }
    return smallDateFormat(date);
  };

  const labels = filteredData
    ? filteredData?.map(elem => getLabel(elem.date))
    : [];

  const data = {
    labels: labels,
    datasets: [{
      label: 'Média Geral (%)',
      data: filteredData
        ? filteredData?.map(elem => elem.mediaGeral)
        : [],
        // backgroundColor: 'rgba(255, 159, 64, 0.2)',
        // borderColor: 'rgb(255, 159, 64)',
        backgroundColor: '#4d86bb',
        borderColor: '#4d86bb',
      borderWidth: 1,
    }]
  };

  const options = {
    responsive: true, // Faz o gráfico responsivo
    maintainAspectRatio: false, // Permite o ajuste da altura
    // scales: {
    //   x: {
    //     display: false
    //   }
    // },
    plugins: {
      legend: {
        display: false
      },
    }
  };

  return (
    <Container>
      <ContentButtons>
        <label htmlFor="filter">Evolução Geral NPS</label>
        <select id="filter" value={filter} onChange={(e) => setFilter(e.target.value)}>
          <option value="day">Dia</option>
          <option value="month">Mes</option>
          <option value="year">Ano</option>
        </select>
      </ContentButtons>
      <div style={{ maxHeight: '250px', height: '100%', width: '100%', maxWidth: "500px" }}>

      <Bar height={300} data={data} options={options} />
      </div>
    </Container>
  );
};

export default NpsGraph;

